import {useEffect, useRef} from 'react';

export default function TimeoutTimer({time, isTimeout, onTimeout}) {
    const timerRef = useRef(null);
    const onTimeoutRef = useRef(onTimeout);

    useEffect(() => {
        onTimeoutRef.current = onTimeout;
    });

    useEffect(() => {
        if (time <= 0 || isTimeout) {
            return;
        }

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
            onTimeoutRef.current();
        }, time);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [time, isTimeout]);

    return null;
}
